/* eslint-disable */
import ReactGA from 'react-ga';
import { api } from '../../redux/api';

function navigateToCheckoutPage(pageUrl) {
  if (!pageUrl) return;

  // Backend builds https://{host}/charging|start|startError — local host is often
  // "localhost" so the iframe would leave http://127.0.0.1:3000 and go blank
  // (bad TLS / X-Frame-Options). Keep SPA navigations on the current origin.
  try {
    const parsed = new URL(pageUrl, window.location.origin);
    const path = parsed.pathname || '';
    if (path.startsWith('/charging') || path.startsWith('/start') || path.startsWith('/startError')) {
      window.location.assign(`${path}${parsed.search}${parsed.hash}`);
      return;
    }
  } catch (_) {
    /* fall through to full href */
  }

  // On iOS, full URL assignment after async can open in external Safari.
  // Same-origin (e.g. start-from-balance → /charging) must stay in WebView.
  const isIos =
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  if (isIos) {
    try {
      const parsed = new URL(pageUrl);
      if (parsed.origin === window.location.origin) {
        const sameOriginPath = parsed.pathname + parsed.search + parsed.hash;
        window.location.href = sameOriginPath;
        return;
      }
    } catch (_) {
      /* fallback to full href */
    }
  }

  window.location.href = pageUrl;
}

function checkoutErrorMessage(error) {
  const errorMessage = error?.data?.data || error?.data?.message || error?.status || '';
  if (typeof errorMessage === 'string' && errorMessage.includes('Payment Not configured')) {
    return errorMessage;
  }
  return error.status || errorMessage;
}

export const startCharging = () => {
  const [getPaymentLink] = api.useLazyGenerateCheckoutLinkKwtQuery();
  const [skipPaymentLocal] = api.useLazySkipPaymentLocalQuery();
  const [startFree] = api.useLazyDeviceStartQuery();

  const startChargingFree = async stationNumber => {
    // Check if clientId is saved in localStorage
    const savedClientId = localStorage.getItem('clientId');
    if (!savedClientId) {
      return 'CLIENT_ID_NOT_READY';
    }

    const { error } = await startFree({ stationNumber });
    ReactGA.event({
      category: 'startChargingFree',
      action: 'start free',
    });
    if (error) return error?.data?.data;
    return 'success';
  };

  const openPaymentLink = async (stationNumber, kwt, autoStart, setError) => {
    // Check if clientId is saved in localStorage
    const savedClientId = localStorage.getItem('clientId');
    if (!savedClientId) {
      if (setError) {
        setError('CLIENT_ID_NOT_READY');
      }
      return;
    }

    kwt = Number(kwt);

    const { data, isSuccess, error } = await getPaymentLink({
      stationNumber,
      kwt,
      autoStart,
    });

    if (error) {
      if (setError) {
        setError(checkoutErrorMessage(error));
      }
      return;
    }

    if (isSuccess) {
      navigateToCheckoutPage(data?.pageUrl);
    }
  };

  const skipPaymentAndStart = async (stationNumber, kwt, autoStart, setError) => {
    const savedClientId = localStorage.getItem('clientId');
    if (!savedClientId) {
      if (setError) {
        setError('CLIENT_ID_NOT_READY');
      }
      return;
    }

    kwt = Number(kwt);

    const { data, isSuccess, error } = await skipPaymentLocal({
      stationNumber,
      kwt,
      autoStart,
    });

    if (error) {
      if (setError) {
        setError(checkoutErrorMessage(error));
      }
      return;
    }

    if (isSuccess) {
      navigateToCheckoutPage(data?.pageUrl);
    }
  };

  return {
    startChargingFree,
    openPaymentLink,
    skipPaymentAndStart,
  };
};
